import { lazy } from "react";
import { Route } from "../RouteModel";

const BankList = lazy(() => import("../../pages/administration/banks/List"));
const BankDetails = lazy(
  () => import("../../pages/administration/banks/Details")
);
const BankEdit = lazy(() => import("../../pages/administration/banks/Edit"));
const BankCreate = lazy(
  () => import("../../pages/administration/banks/Create")
);

export const bankRoutes: Route = {
  i18nName: "Banks",
  path: "/administration/banks",
  component: BankList,
  showChildrenInSidebar: false,
  can: {
    do: "list",
    on: "bank",
  },
  children: [
    {
      path: "/administration/banks/create",
      i18nName: "Create bank",
      component: BankCreate,
      can: {
        do: "create",
        on: "bank",
      },
    },
    {
      path: "/administration/banks/:id/edit",
      i18nName: "Edit bank",
      component: BankEdit,
      can: {
        do: "update",
        on: "bank",
      },
    },
    {
      path: "/administration/banks/:id",
      i18nName: "Bank",
      component: BankDetails,
      can: {
        do: "details",
        on: "bank",
      },
    },
  ],
};
